import { StrictMode } from 'react'

import { createRoot } from 'react-dom/client'

import App from './App'
import { ThemeProvider } from './contexts/ThemeContext'
import { loadSportConfig } from './services/sportConfigService'
import './index.css'

// Templates read sport config synchronously while rendering, so load it first.
loadSportConfig().finally(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </StrictMode>
  )
})
